import { Drawer } from '@library/components/navigation/Drawer';

export interface MemberDrawerProps {
  children: React.ReactNode;
  isOpen: boolean;
  onCloseDrawer: () => void;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
}

export const MemberDrawer = ({
  children,
  isOpen,
  onCloseDrawer,
  size = 'medium'
}: MemberDrawerProps) => {
  return (
    <Drawer
      isOpen={isOpen}
      onCloseDrawer={onCloseDrawer}
      direction="right"
      size={size}
    >
      {children}
    </Drawer>
  );
};
